import { useEffect, useState } from "react";
import { MousePointer2 } from "lucide-react";

const find = (target) => {
  for (const t of target.split(",")) {
    const el = t.startsWith("#") ? document.querySelector(t) : document.querySelector(`[data-testid="${t}"]`);
    if (el && el.getBoundingClientRect().width > 0) return el;
  }
  if (target.startsWith("nav-")) return document.querySelector('[data-testid="mobile-menu-button"]');
  return null;
};

export function Spotlight({ target }) {
  const [rect, setRect] = useState(null);
  useEffect(() => {
    let el = null;
    let tries = 0;
    const measure = () => {
      if (!el) {
        el = find(target);
        if (el) {
          const tall = el.getBoundingClientRect().height > window.innerHeight * 0.45 || window.innerWidth < 640;
          if (tall) window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - 90), behavior: "smooth" });
          else el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        else if (++tries > 20) return;
      }
      if (el) {
        const r = el.getBoundingClientRect();
        const top = Math.max(4, r.top - 6);
        setRect({ top, left: r.left - 6, width: r.width + 12, height: Math.max(0, Math.min(r.bottom + 6, window.innerHeight - 4) - top) });
      }
    };
    measure();
    const iv = setInterval(measure, 200);
    return () => clearInterval(iv);
  }, [target]);
  if (!rect) return null;
  return (
    <>
      <div className="tour-spot" style={rect} data-testid="tour-spotlight" />
      <div className="fixed z-[9999] pointer-events-none tour-point" style={{ top: Math.min(rect.top + rect.height - 4, window.innerHeight - 40), left: Math.min(rect.left + rect.width - 4, window.innerWidth - 40) }}>
        <MousePointer2 className="h-7 w-7 text-amber-400 fill-amber-400 drop-shadow-lg" />
      </div>
    </>
  );
}
